import { render, staticRenderFns } from "./payPopup.vue?vue&type=template&id=fa6eb486&scoped=true"
import script from "./payPopup.vue?vue&type=script&lang=js"
export * from "./payPopup.vue?vue&type=script&lang=js"
import style0 from "./payPopup.vue?vue&type=style&index=0&id=fa6eb486&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6eb486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa6eb486')) {
      api.createRecord('fa6eb486', component.options)
    } else {
      api.reload('fa6eb486', component.options)
    }
    module.hot.accept("./payPopup.vue?vue&type=template&id=fa6eb486&scoped=true", function () {
      api.rerender('fa6eb486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/institutionalWalletChild/child/payPopup.vue"
export default component.exports